const translationMapping = {
    adult: {
        label: 'search.form.label.adult',
        description: 'search_bundle.search_widget.adults_description',
    },
    children: {
        label: 'search.form.label.children',
        description: 'search_bundle.search_widget.children_description',
    },
    children_0_5: {
        label: 'search.form.label.children_0_5',
        description: 'search_bundle.search_widget.children_0_5_description',
    },
    children_0_11: {
        label: 'search.form.label.children_0_11',
        description: 'search_bundle.search_widget.children_0_11_description',
    },
    children_6_14: {
        label: 'search.form.label.children_6_14',
        description: 'search_bundle.search_widget.children_6_14_description',
    },
    children_6_11: {
        label: 'search.form.label.children_6_11',
        description: 'search_bundle.search_widget.children_6_11_description',
    },
    children_12_17: {
        label: 'search.form.label.children_12_17',
        description: 'search_bundle.search_widget.children_12_17_description',
    },
    children_12_15: {
        label: 'search.form.label.children_12_15',
        description: 'search_bundle.search_widget.children_12_15_description',
    },
    pensioner: {
        label: 'search.form.label.pensioner',
        description: 'search_bundle.search_widget.pensioner_description',
    },
    student: {
        label: 'search.form.label.student',
        description: 'search_bundle.search_widget.students_description',
    },
    pupil: {
        label: 'search.form.label.pupil',
        description: 'search_bundle.search_widget.pupil_description',
    },
    pwd: {
        label: 'search.form.label.pwd',
        description: 'search_bundle.search_widget.pwd_description',
    },
    bike_slot: {
        label: 'search.form.label.bike_slot',
        description: 'search_bundle.search_widget.bikes_description',
    },
    ch_adult_halb_tax: {
        label: 'search.form.label.ch_adult_halb_tax',
        description: 'search_bundle.search_widget.ch_adult_halb_tax_description',
    },
    ch_adult_general_abonnement: {
        label: 'search.form.label.ch_adult_general_abonnement',
        description: 'search_bundle.search_widget.ch_adult_general_abonnement_description',
    },
    ch_children_6_15: {
        label: 'search.form.label.ch_children_6_15',
        description: 'search_bundle.search_widget.ch_children_6_15_description',
    },
    children_6_17: {
        label: 'search.form.label.children_6_17',
        description: 'search_bundle.search_widget.children_6_17',
    },
    senior: {
        label: 'search.form.label.senior',
        description: 'search_bundle.search_widget.senior',
    },
    wheelchair: {
        label: 'search.form.label.wheelchair',
        description: 'search_bundle.search_widget.wheelchair',
    },
    tr_pwd: {
        label: 'search.form.label.tr_pwd',
        description: 'search_bundle.search_widget.tr_pwd_description',
    },
};

export const getProductTranslationKey = (productType, type) => {
    if (productType.indexOf('.') === -1 && productType.startsWith('pl_') && type === 'label') {
        return `passenger.${productType}`;
    }

    if (!translationMapping[productType] || !translationMapping[productType][type]) {
        return productType;
    }

    return translationMapping[productType][type];
};
